import { render, staticRenderFns } from "./DetailOne.vue?vue&type=template&id=268ac77e&scoped=true"
import script from "./DetailOne.vue?vue&type=script&lang=js"
export * from "./DetailOne.vue?vue&type=script&lang=js"
import style0 from "./DetailOne.vue?vue&type=style&index=0&id=268ac77e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268ac77e",
  null
  
)

export default component.exports